import template from './rw-terms-of-use-dialog.html';

export default {
  template,
  controller: 'RwTermsOfUseDialogController',
  bindings: {
    resolve: '<',
    close: '&',
  },
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-terms-of-use/components/rw-terms-of-use-dialog-component.js